import React from 'react';
import { checkSubjectNameFormat, parseSubjectName } from 'src/utils/cades';
import styles from './styles.module.scss';

type Props = {
  certificate: {
    subjectName: string;
    validFromDate: string;
    validToDate: string;
  };
};

const formatCertDate = (date: any) => date.format('DD.MM.YYYY H:mm');

const CertOptionLabel: React.FC<Props> = ({ certificate }) => {
  const { subjectName, validFromDate, validToDate } = certificate;

  const isSubjectNameFormatted = checkSubjectNameFormat(subjectName);
  if (!isSubjectNameFormatted) {
    return <>{subjectName}</>;
  }

  const subjectNameObj = parseSubjectName(subjectName);

  if (subjectNameObj.hasOwnProperty('ИНН ЮЛ')) {
    return (
      <div>
        <div className={styles['flex-row']}>
          <span className={styles['common-name']}>{subjectNameObj['CN']}</span>
          &nbsp; &nbsp;
          <span className={styles['inn']}>{subjectNameObj['ИНН ЮЛ']}</span>
        </div>
        <div className={styles['flex-row']}>
          <span>
            {subjectNameObj['SN']} {subjectNameObj['G']}
          </span>
          &nbsp; &nbsp;
          <span className={styles['role']}>{subjectNameObj['T']}</span>
        </div>
        <div>
          Действителен: {formatCertDate(validFromDate)} — {formatCertDate(validToDate)}
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className={styles['flex-row']}>
        <span className={styles['common-name']}>{subjectNameObj['CN']}</span>
        &nbsp; &nbsp;
        <span className={styles['inn']}>{subjectNameObj['ИНН']}</span>
      </div>
      <div>
        {subjectNameObj['SN']} {subjectNameObj['G']}
      </div>
      <div>
        Действителен: {formatCertDate(validFromDate)} — {formatCertDate(validToDate)}
      </div>
    </div>
  );
};

export default CertOptionLabel;
